import { render, staticRenderFns } from "./FirstLastClass.vue?vue&type=template&id=4b93db82&"
import script from "./FirstLastClass.vue?vue&type=script&lang=js&"
export * from "./FirstLastClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports